import React from "react";
import { useDispatch } from "react-redux";
import { useFeature } from "flagged";

import AddToStarred from "../AddToStarred/AddToStarred";
import AddToNextShift from "../AddToNextShift/AddToNextShift";
import ToggleDoToday from "../ToggleDoToday/ToggleDoToday";
import UnreadActivitiesCount from "../../Activities/UnreadActivitiesCount/UnreadActivitiesCount";
import TaskConfirmedActivityDisplay from "../../Tasks/TaskConfirmedActivityDisplay/TaskConfirmedActivityDisplay";
import TaskDraftActivityDisplay from "../../Tasks/TaskDraftActivityDisplay/TaskDraftActivityDisplay";
import LabelDisplay from "../LabelDisplay/LabelDisplay";
import WatchDisplay from "../WatchDisplay/WatchDisplay";

import { getActivityListService } from "../../../services/activities.service";
import { dispatchError } from "../../../utils/error.util";

import ws from "../../../sockets/websockets";

const TaskCardTags: React.FC<TaskCardTagsProps> = ({ checklist, task }) => {
  const dispatch = useDispatch();
  const isDev = useFeature("under_development");

  // const [confirmedActivities, setConfirmedActivities] = React.useState<
  //   ActivityArray
  // >([]);

  const displayChecklist = checklist && checklist.length > 0;
  const {
    id: taskId,
    unread_activities_count: taskUnreadActivitiesCount,
    draft_activities_count: taskDraftActivitiesCount,
  } = task;

  // const getTaskConfirmedActivities = React.useCallback(async () => {
  //   try {
  //     const data = {
  //       confirmed: true,
  //       task: taskId,
  //     };
  //     const response = await getActivityListService(data);
  //     if (response.status === 200) {
  //       setConfirmedActivities(response.data);
  //     }
  //   } catch (e) {
  //     const error = (e as Error).message;
  //     dispatchError({
  //       title: "Populate activities error",
  //       error,
  //     });
  //   }
  // }, [dispatch, taskId]);

  React.useEffect(() => {
    /**
     * TODO 13.14.2 - request task endpoint to include
     * drafts count (unconfirmed and not submitted) and unread activities count
     * then update logic  so we do not have to send request for each tasks
     */
    // getTaskConfirmedActivities();

    const wsOnMessage = async (event: MessageEvent) => {
      try {
        const messageEventData = JSON.parse(event.data);
        const { event: eventType, meta } = messageEventData;
        const { task_id: metaTaskId } = meta;
        switch (eventType.trim()) {
          case "new_activity":
            if (taskId === metaTaskId) {
              // getTaskConfirmedActivities();
            }
            break;
        }
      } catch (e) {}
    };
    ws.addEventListener("message", wsOnMessage);

    return () => {
      ws.removeEventListener("message", wsOnMessage);
    };
  }, [
    taskId,
    // getTaskConfirmedActivities
  ]);

  return (
    <div className="TaskCardTags">
      <ToggleDoToday task={task} />
      <div className="TaskCardTags__Dot" />
      <AddToNextShift task={task} />
      <div className="TaskCardTags__Dot" />
      <AddToStarred task={task} />

      {/*
       * Temporarily removed until BE is implemented, bug 20220207-2
       * <div className="TaskCardTags__Dot" />
       * <WatchDisplay task={task} />
       */}
      {isDev && (
        <>
          <div className="TaskCardTags__Dot" />
          <LabelDisplay task={task} />
        </>
      )}
      {/* Temporarily removed Bug 20211214-4
      {displayChecklist ? (
        <>
          <div className="TaskCardTags__Dot" />
          <TaskChecklist checklist={checklist} />
        </>
      ) : null}
      */}
      <>
        <div className="TaskCardTags__Dot" />
        <UnreadActivitiesCount
          hasIcon={true}
          count={taskUnreadActivitiesCount || 0}
        />
      </>
      {/*
        * Bug 20211223-2
        * Temporarily removed until auto-generated activities have been implemented      
      {confirmedActivities.length > 0 ? (
        <>
          <div className="TaskCardTags__Dot" />
          <TaskConfirmedActivityDisplay />
        </>
      ) : null}
      */}
      {!!taskDraftActivitiesCount && (
        <>
          <div className="TaskCardTags__Dot" />
          <TaskDraftActivityDisplay />
        </>
      )}
    </div>
  );
};

export default TaskCardTags;
